import script from "./logout.vue?vue&type=script&setup=true&name=logout&lang=js"
export * from "./logout.vue?vue&type=script&setup=true&name=logout&lang=js"

const __exports__ = script;

export default __exports__